import { render, staticRenderFns } from "./CalendarDisplay.vue?vue&type=template&id=296d6af8&"
import script from "./CalendarDisplay.vue?vue&type=script&lang=js&"
export * from "./CalendarDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports